<template>
  <section class='home-video-list'>

    <div class="line">
      <span>━━━</span>
      <span class="nickname"> @{{$store.state.userInfo.nickName}}</span>
      <span>━━━</span>
    </div>

    <div>
      <van-list
        v-model="worksLoading"
        :finished="worksFinished"
        @load="worksOnLoad"
      >
        <list-item
          :data='worksList'
          @goPlay="goPlay"
        />

      </van-list>
      <openBar position="bottom" />
    </div>

  </section>
</template>

<script>
import listItem from '@/components/list-item/index.vue';
import openBar from '@/components/open-bar/index.vue';
import { apiGetUserWorksList } from '@/api/user-center';

export default {
  components: {
    openBar,
    listItem,
  },
  data() {
    return {
      allWorksList: [],
      worksPN: 1,
      worksList: [],
      worksLoading: false,
      worksFinished: false,
      pageSize: 18,
    };
  },
  methods: {
    async worksOnLoad() {
      const { userId, snowId } = this.$route.query;
      const { data } = await apiGetUserWorksList({
        userId,
        pageNumber: this.worksPN,
        pageSize: this.pageSize,
      });
      const { results, totalPages } = data;
      this.allWorksList = this.allWorksList.concat(results);
      if (totalPages === this.worksPN) {
        this.worksFinished = true;
      }
      const index = this.allWorksList.findIndex(o => o.snowId === snowId);
      if (index !== -1) {
        this.allWorksList.splice(index, 1);
      }
      this.worksPN += 1;
      const newWorksList = [];
      for (let i = 0; i < this.allWorksList.length; i += 3) {
        newWorksList.push(this.allWorksList.slice(i, i + 3));
      }
      this.worksList = newWorksList;
      this.worksLoading = false;
    },
    goPlay({ snowId, userId }) {
      this.$router.push({
        name: 'Home',
        query: {
          snowId,
          userId,
        },
      });
    },
  },
};
</script>

<style lang='less' scoped>
.home-video-list {
  padding-bottom: 60px;
  background: #000000;
  .line {
    color: #ffffff;
    font-size: 16px;
    text-align: center;
    padding: 10px 0;
    background: #162945;
  }
  .nickname {
    max-width: 200px;
    display: inline-block;
    padding: 0 10px;
    line-height: 25px;
  }
}
</style>
